import { cronosClient } from "@/config/client"
import type { MilestoneType } from "./get"

export interface CreateMilestoneDto {
  title: string
  date: string
  courseId: string
  type: MilestoneType
  unitIds: string[]
}

export function create(payload: CreateMilestoneDto) {
  return cronosClient.post("/v1/milestones", payload)
}
